module.exports = __webpack_public_path__ + "static/investors-info2-57f6ca6d34f0962291e06d9f9df460cc.jpg";